import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { MultisiteFlagComponent } from '../../flag/multisite-flag.component';
import { MultisiteSwitchComponent } from '../multisite-switch.component';

@Component({
    selector: 'multisite-switch-simple',
    templateUrl: './multisite-switch-simple.component.html',
    styleUrls: ['./../multisite-switch.component.scss'],
    standalone: true,
    imports: [MultisiteFlagComponent, ToggleModule, NgStyle],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteSwitchSimpleComponent extends MultisiteSwitchComponent {
    @Input()
    simpleMultisite = true;
    @Input()
    headerSelector = false;

    protected override asyncCd = false;

    @NgInject(ToggleService)
    protected toggleService: ToggleService;
    readonly toggleGroup = 'group';
    open(id: NToggle.TId): void {
        this.toggleService.open(id);
    }
    toggle(id: NToggle.TId): void {
        this, this.toggleService.toggle(id);
    }
}
